export const DETAILS_SOURCE = 'contact-list-details';
export const DASHBOARD_SOURCE = 'contact-list-dashboard';
export const META_SOURCE_UPLOAD = 'CONTACT_LIST_UPLOAD';

export const MAX_CONTACTS = 100000;

export const CONTACT_LIST_STATUS_ENUM = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  IMPORTING: 'IMPORTING',
};

export const CONTACT_LIST_UPDATE_STATUS = {
  IMPORTING: 'IMPORTING',
  PROCESSED: 'PROCESSED',
};

export const TEMPLATE_EXTENSIONS = {
  CSV: 'csv',
  XLSX: 'xlsx',
};

export const ADD_MODE = {
  UPLOAD: 'UPLOAD',
  MANUALLY: 'MANUALLY',
};
